// 初期表示
export const PAGE_INIT = "corp/ma-event/PAGE_INIT";
// 期間選択
export const SEARCH_PAGE = "corp/ma-event/SEARCH_PAGE";
// ページング
export const PAGER_CHANGE = "corp/ma-event/PAGER_CHANGE";
// 初期化
export const ALL_RESET = "corp/ma-event/ALL_RESET";
